// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema, urlSchema } from '../../utils/codecUtils.schema';

export const organizationGroupOrganizationSchema = z.object({
  id: idSchema,
  name: z.string(),
  url: urlSchema,
});
